import { ErrorData } from 'ok-angular-shared/components';

export const appErrorCodes: ErrorData[] = [
  {
    code: 1,
    message: `Der er sket en uventet fejl.`,
  },
];
